import { useState, useEffect } from "react";
import styles from "./OfflineBanner.module.css";

export default function OfflineBanner() {
  const [offline, setOffline] = useState(!navigator.onLine);
  const [showReturned, setShowReturned] = useState(false);

  useEffect(() => {
    const handleOffline = () => {
      setOffline(true);
      setShowReturned(false);
    };
    const handleOnline = () => {
      setOffline(false);
      setShowReturned(true);
      const t = setTimeout(() => setShowReturned(false), 3000);
      return () => clearTimeout(t);
    };
    window.addEventListener("offline", handleOffline);
    window.addEventListener("online",  handleOnline);
    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online",  handleOnline);
    };
  }, []);

  if (!offline && !showReturned) return null;

  return (
    <div
      className={`${styles.banner} ${offline ? styles.offline : styles.online}`}
      role="status"
      aria-live="polite"
    >
      {offline
        ? "📶 Sem conexão - verifique sua internet"
        : "✅ Conexão restaurada"}
    </div>
  );
}
